import { asPage } from 'src/components/hoc/asPage'
import { ExhibitionPage } from 'src/compositions/Exhibition'

export default asPage(ExhibitionPage, {
  pageTitle: 'オンライン展示会',
  noindex: false,
})
